import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Trans, t } from "@lingui/macro";

import { i18n } from "base/i18n";
import { Modal } from "widgets/modal";
import { Scrollbar } from "widgets/scrollbar";
import {
  Button,
  BUTTON_TYPES,
  BUTTON_SIZES,
  Radio,
  MultiLine
} from "widgets/inputs";
import { Validation, Validator, ValidateWithMessage } from "widgets/validation";

import {
  MAX_CHARACTERS,
  REASONS_FOR_DELETION
} from "../../common/utils/constant";

import styles from "./post.css";

RemovePostModal.propTypes = {
  showRemovePost: PropTypes.func,
  removePostModal: PropTypes.func,
  title: PropTypes.node
};

export function RemovePostModal({ showRemovePost, removePostModal, title }) {
  const [isModalOpen, setModalOpen] = useState(true);
  const [deleteReason, setdeleteReason] = useState(
    REASONS_FOR_DELETION.INCORRECT
  );
  const [otherReason, setOtherReason] = useState("");
  const [error, setError] = useState({});
  const validationRef = useRef(null);

  function cancelSetting() {
    setModalOpen(false);
    showRemovePost(false);
  }

  function saveSetting() {
    const newerror = validationRef.current && validationRef.current.validate();
    setError({ ...newerror });
    let valid =
      (newerror && Object.values(newerror).filter((val) => !!val)) || [];
    if (valid.length > 0) return;
    let data = { Reason: deleteReason._id };
    if (deleteReason._id === REASONS_FOR_DELETION.OTHER._id) {
      data["Detail"] = otherReason;
    }
    if (deleteReason && !error.Description) {
      removePostModal(data);
      setModalOpen(false);
      showRemovePost(false);
    }
  }

  function updateReason(Reason) {
    setdeleteReason(Reason);
    setError({});
  }

  function onChangeReason(evt) {
    let value = evt.target.value;
    value = trimCharacters(value, MAX_CHARACTERS.DELETE_REASON);
    setOtherReason(value);
  }

  function trimCharacters(value, maxLength) {
    return value.substr(0, maxLength + 1);
  }

  const onValidate = (err) => {
    setError({ ...err });
  };

  return (
    <Modal
      titleRenderer={() => <span>{title}</span>}
      width="40rem"
      rightActionsRenderer={() => (
        <div className={styles.removeModalFooter}>
          <Button
            type={BUTTON_TYPES.SECONDARY}
            size={BUTTON_SIZES.MEDIUM}
            onClick={cancelSetting}
          >
            <Trans>Cancel</Trans>
          </Button>
          <Button
            type={BUTTON_TYPES.ERROR}
            size={BUTTON_SIZES.MEDIUM}
            onClick={saveSetting}
          >
            <Trans>Remove</Trans>
          </Button>
        </div>
      )}
      open={isModalOpen}
      onClose={cancelSetting}
    >
      <Scrollbar scrollX={true}>
        <div className={styles.removePostContainer}>
          <div className={`smallplus ${styles.reasonSubHeading}`}>
            <Trans>Reason</Trans>
          </div>
          <Validation ref={validationRef}>
            {Object.values(REASONS_FOR_DELETION).map((reason) => (
              <Radio
                key={reason._id}
                className={styles.optionItem}
                label={i18n._(reason.Name)}
                id={reason._id}
                checked={deleteReason._id === reason._id}
                onChange={() => updateReason(reason)}
              />
            ))}
            {deleteReason._id === REASONS_FOR_DELETION.OTHER._id && (
              <div className={styles.textareaContainer}>
                <Validator
                  name="Description"
                  value={otherReason}
                  validations={[
                    ValidateWithMessage.required(
                      i18n._(t`This field cannot be left empty`)
                    ),
                    ValidateWithMessage.maxLength(MAX_CHARACTERS.DELETE_REASON)(
                      i18n._(
                        t`The reason must be less than or equal to ${MAX_CHARACTERS.DELETE_REASON} characters`
                      )
                    )
                  ]}
                  onValidate={onValidate}
                >
                  <MultiLine
                    name="Description"
                    autoFocus={true}
                    className={styles.removeTextarea}
                    value={otherReason}
                    placeholder={i18n._(t`Enter reason`)}
                    onChange={(evt) => onChangeReason(evt)}
                  />
                </Validator>
                {error.Description && (
                  <div className={`tiny ${styles.errorText}`}>
                    {error.Description}
                  </div>
                )}
              </div>
            )}
          </Validation>
        </div>
      </Scrollbar>
    </Modal>
  );
}
